import apiUrl from "../../../../../utils/settings";

export const canDeleteAccountUrl = () => {
  return apiUrl + `/users/can-delete-account`;
};

export const deleteAccountUrl = () => {
  return apiUrl + `/users`;
};